import { useState } from "react";
import PromptInput from "@amzn/awsui-components-console/prompt-input";
import FormField from "@amzn/awsui-components-console/form-field";

import { getString } from '../../../common/ui-string-labels/ui-strings-utils';

interface ChatInputProps {
    onSend: (message: string) => void;
    isLoading: boolean;
    maxChars: number;
}

const ChatInput = ({ onSend, isLoading, maxChars }: ChatInputProps) => {
    const [value, setValue] = useState("");
    const trimmed = value.trim();

    const handleSend = () => {
        if (!trimmed || isLoading || trimmed.length > maxChars) return;
        onSend(trimmed);
        setValue("");
    };

    return (
        <FormField
            stretch={true}
            constraintText={<>{trimmed.length} / {maxChars}</>}
            errorText={trimmed.length > maxChars && getString('chatbot.messages.tooLong')}
        >
            <PromptInput
                value={value}
                onChange={({ detail }) => setValue(detail.value)}
                onAction={handleSend}
                actionButtonAriaLabel={getString('chatbot.input.sendButtonAriaLabel')}
                actionButtonIconName="send"
                ariaLabel={getString('chatbot.input.ariaLabel')}
                minRows={1}
                maxRows={3}
                placeholder={getString('chatbot.input.placeholder')}
                disabled={isLoading}
                disableActionButton={!trimmed || trimmed.length > maxChars}
                invalid={trimmed.length > maxChars}
            />
        </FormField>
    );
};

export default ChatInput;
